import { supabase } from "@shared/lib/supabase/client";
import { Button } from "@shared/ui/button";
import { Card, CardDescription, CardHeader, CardTitle } from "@shared/ui/card";
import { useState } from "react";
import { FormattedMessage, useIntl } from "react-intl";
import { toast } from "sonner";

export function SessionsCard() {
	const intl = useIntl();
	const [signingOut, setSigningOut] = useState(false);

	const onSignOutOthers = async () => {
		setSigningOut(true);
		try {
			const { error } = await supabase.auth.signOut({ scope: "others" });
			if (error) throw error;
			toast.success(
				intl.formatMessage({
					id: "page.profile.sessions.signOutSuccess",
					defaultMessage: "Signed out of all other sessions.",
				})
			);
		} catch (err: any) {
			toast.error(
				err.message ??
					intl.formatMessage({
						id: "page.profile.sessions.signOutError",
						defaultMessage: "Failed to sign out other sessions.",
					})
			);
		} finally {
			setSigningOut(false);
		}
	};

	return (
		<Card>
			<CardHeader className="flex justify-between items-center">
				<div className="flex-col">
					<CardTitle>
						<FormattedMessage id="page.profile.sessions.title" defaultMessage="Active sessions" />
					</CardTitle>
					<CardDescription>
						<FormattedMessage
							id="page.profile.sessions.description"
							defaultMessage="Devices currently signed in to your account."
						/>
					</CardDescription>
				</div>
				<Button variant="outline" onClick={onSignOutOthers} disabled={signingOut}>
					{signingOut ? (
						<FormattedMessage id="page.profile.sessions.signingOut" defaultMessage="Signing out…" />
					) : (
						<FormattedMessage
							id="page.profile.sessions.signOutOthers"
							defaultMessage="Sign out all other sessions"
						/>
					)}
				</Button>
			</CardHeader>
		</Card>
	);
}
